import { CSSObject } from '@mui/material/styles';
import { baseTheme } from '../../base-theme';

export function generateFocusRingStyles(focusClass: string, overrides?: CSSObject) {
    return {
        outlineColor: baseTheme.palette.focusRing,
        outlineWidth: baseTheme.tokens.borderWidth.md,
        outlineOffset: '0.125rem',
        outlineStyle: 'none',
        [`&.${focusClass}`]: {
            outline: `${baseTheme.tokens.borderWidth.md} solid ${baseTheme.palette.focusRing}`,
            outlineStyle: 'solid',
        },
        ...(overrides || {}),
    };
}
